import React from 'react';
import "./Recommended.css";
import VideoCard from './VideoCard';

function Recommended() {
    return (
        <div className="recommended">
            <h2>Recommended</h2>
            <div className="recommended_videos">
            <VideoCard
                title="How to Create Blog in 1 hour"
                views="1.1M Views"
                timestamp="1 days ago"
                image="https://embed-fastly.wistia.com/deliveries/3660f4608f30cfdf5300e0822ce5f5b6.webp?image_crop_resized=1280x720"
                channel="Sonny"
                channelImage='https://i.ibb.co/tY0DP1g/Jun302020-13054.jpg' 

            ></VideoCard>
             <VideoCard
                title="Learn Web Development as an Absolute Beginner| 2019/2020"
                views="2.3M Views"
                timestamp="3 days ago"
                image="https://careerfoundry.com/en/blog/uploads/web_dev_pillar_page.jpg"
                channel="Sangha"
                channelImage='https://i.ibb.co/tY0DP1g/Jun302020-13054.jpg'

            ></VideoCard>
             <VideoCard
                title="Web development in 2020 | A Practical Guide"
                views="1.3M Views"
                timestamp="1 days ago"
                image="https://i.ytimg.com/vi/0pThnRneDjw/hqdefault.jpg"
                channel="Sonny Rafeh"
                channelImage='https://i.ibb.co/tY0DP1g/Jun302020-13054.jpg'

            ></VideoCard>
             <VideoCard
                title="My Salary History as A Web Developer"
                views="2.3B Views"
                timestamp="2 days ago"
                image="https://embed-fastly.wistia.com/deliveries/3660f4608f30cfdf5300e0822ce5f5b6.webp?image_crop_resized=1280x720"
                channel="Sonny Sangha"
                channelImage='https://i.ibb.co/tY0DP1g/Jun302020-13054.jpg'

            ></VideoCard>
             <VideoCard
                title="Become a Web Developer in 10 minutes | 2019/2020"
                views="2.3M Views"
                timestamp="3 days ago"
                image="https://i.ytimg.com/vi/ckiaNqOrG5U/maxresdefault.jpg"
                channel="Sonny Sangha"
                channelImage='https://i.ibb.co/tY0DP1g/Jun302020-13054.jpg'

            ></VideoCard>
            <VideoCard
                title="WEb Developer vs Web Designer"
                views="1.1M Views"
                timestamp="1 days ago"
                image="https://cdn.lynda.com/static/landing/images/hero/Front-End_Web_Developer_1200x630-1503690324422.jpg"
                channel="Rafeh Kaji"
                channelImage='https://i.ibb.co/tY0DP1g/Jun302020-13054.jpg'

            ></VideoCard>
             <VideoCard
                title="A Day in Life of a Software Engineer | React.js"
                views="2.1B Views"
                timestamp="10 days ago"
                image="https://careerfoundry.com/en/blog/uploads/web_dev_pillar_page.jpg"
                channel="Nishat Mithila"
                channelImage='https://i.ibb.co/tY0DP1g/Jun302020-13054.jpg'

            ></VideoCard>
             <VideoCard
                title="Web Developer Roadmap | 2019/2020"
                views="2.3M Views"
                timestamp="3 days ago"
                image="https://i.ytimg.com/vi/lT4uJI6TXAg/hqdefault.jpg"
                channel="Sonny Sangha"
                channelImage='https://i.ibb.co/tY0DP1g/Jun302020-13054.jpg'

            ></VideoCard>
             <VideoCard
                title="Become a Web Developer in 1 month"
                views="1.2M Views"
                timestamp="3 days ago"
                image="https://i.ytimg.com/vi/nusgoj74a3Y/maxresdefault.jpg"
                channel="Nishat Tasnim"
                channelImage='https://i.ibb.co/tY0DP1g/Jun302020-13054.jpg'

            ></VideoCard>
             <VideoCard
                title="How A Get a Web Developer Job"
                views="2.3B Views"
                timestamp="1 days ago"
                image="https://i.pinimg.com/originals/9b/ea/59/9bea59faa51642d7b6197174c80f2087.jpg"
                channel="Sonny Sangha"
                channelImage='https://i.ibb.co/tY0DP1g/Jun302020-13054.jpg'

            ></VideoCard>
             <VideoCard
                title="Web Developer Roadmap | 2019/2020"
                views="1M Views"
                timestamp="3 days ago"
                image="https://cdn.lynda.com/static/landing/images/hero/Front-End_Web_Developer_1200x630-1503690324422.jpg"
                channel="Nishat Tasnim"
                channelImage='https://i.ibb.co/tY0DP1g/Jun302020-13054.jpg'

            ></VideoCard>
             <VideoCard
                title="Complete Roadmap for Android Development"
                views="2M Views"
                timestamp="5  days ago"
                image="https://careerfoundry.com/en/blog/uploads/web_dev_pillar_page.jpg"
                channel="Rafeh Kaji"
                channelImage='https://i.ibb.co/tY0DP1g/Jun302020-13054.jpg'

            ></VideoCard>
            </div>
            
        </div>
    )
}

export default Recommended
